/**
 * Created by nijin on 28/12/16.
 */
import {
  Component, OnInit, Input, AfterContentInit, ContentChild
} from '@angular/core';


@Component({
  selector: 'nuc-wiz-content',
  template:`
   <div [hidden]="!active">
      <ng-content></ng-content>
    </div>
`
})
export class WizardContentComponent implements OnInit,AfterContentInit {
  active: boolean = false;
  @Input() title: string;
  @Input() description: string;
  @Input() order: number;
  @ContentChild('wizStep') wizardContent;
  constructor() { }
  ngOnInit() { }

  ngAfterContentInit(){
    //console.info(this.wizardContent.toArray())
  }



}



// WEBPACK FOOTER //
// ./src/app/things/shared/wizard/wiz-content.component.ts